module.exports = __webpack_public_path__ + "static/media/GCP_titlePage.2660631b.png";